/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ApproveTradingChallengeRegistrationRequestOptions,
  ApproveTradingChallengeRegistrationRequestResponses,
} from '../types/ApproveTradingChallengeRegistrationRequest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Accessible to admins (any challenge), integrators (their own tenant only) and competition managers (their assigned challenges only). Enrolment runs the same checks as add_users, so a challenge that filled up, now overlaps another of the user's challenges, or whose applicant no longer has an empty ledger is rejected with a 409 and the request stays open.
 * @summary Approve a trading challenge registration request
 * {@link /v1/trading_challenges/registration_requests/:request_id/approve}
 */
export function approveTradingChallengeRegistrationRequest<ThrowOnError extends boolean = true>(
  options: Options<ApproveTradingChallengeRegistrationRequestOptions, ThrowOnError>,
): Unwrappable<RequestResult<ApproveTradingChallengeRegistrationRequestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges/registration_requests/{request_id}/approve',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ApproveTradingChallengeRegistrationRequestResponses, ThrowOnError>>,
  )
}
